import { CRUDFactory } from '../CRUDFactory';

/**
 *  Категория вопросов, которые используются для быстрого ответа
*/
export const CRUDQuestionCategory = CRUDFactory('question-categories');

/**
 *  Шоблон быстрого ответа
*/
export const CRUDAnswerTemplates = CRUDFactory('answer-templates');

/**
 *  Сообщения
*/
export const CRUDChatMessages = CRUDFactory('chat-messages');

/**
 *  Расписание приема заявок
*/
export const CRUDSchedule = CRUDFactory('schedules');

/**
 *  Передача заявки
*/
export const CRUDTransfers = CRUDFactory('transfers');

/**
 *  Чат между участниками переданных заявок
*/
export const CRUDInternalChats = CRUDFactory('internal-chats');

/**
 *  Сообщения между участниками переданных заявок
*/
export const CRUDInternalChatMessages = CRUDFactory('internal-chat-messages');

/**
 *  Расписание Вебинаров
*/
export const CRUDWebinarSchedule = CRUDFactory('webinar-schedules');

/**
 *  Роли проектов
*/
export const CRUDProjectRoles = CRUDFactory('project-roles');
